var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftArrowBlueIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 18,
    viewBox: "0 0 11 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 8.94922C0.25 8.77995 0.279297 8.6237 0.337891 8.48047C0.402995 8.33724 0.500651 8.20052 0.630859 8.07031L8.23828 0.628906C8.45964 0.414062 8.72656 0.306641 9.03906 0.306641C9.25391 0.306641 9.44596 0.358724 9.61523 0.462891C9.79102 0.560547 9.93099 0.69401 10.0352 0.863281C10.1393 1.03255 10.1914 1.22461 10.1914 1.43945C10.1914 1.74544 10.071 2.01888 9.83008 2.25977L2.97461 8.94922L9.83008 15.6387C10.071 15.8796 10.1914 16.1562 10.1914 16.4688C10.1914 16.6771 10.1393 16.8659 10.0352 17.0352C9.93099 17.2109 9.79102 17.3477 9.61523 17.4453C9.44596 17.5495 9.25391 17.6016 9.03906 17.6016C8.72656 17.6016 8.45964 17.4909 8.23828 17.2695L0.630859 9.82812C0.500651 9.69792 0.402995 9.5612 0.337891 9.41797C0.279297 9.27474 0.25 9.11849 0.25 8.94922Z",
    fill: "#007AFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrowBlueIcon);
export default __webpack_public_path__ + "static/media/left-arrow-blue-icon.9c62b1a76ad4c0d8519cbfc93251b0a8.svg";
export { ForwardRef as ReactComponent };